import { Box, Divider, Menu, MenuItem, MenuList, Theme, useMediaQuery } from '@mui/material';
import { palette } from '@/theme/constants';
import { useTranslation } from 'next-i18next';
import { templatesSelector } from '@/store/selectors';
import { useEffect } from 'react';
import { getTabsFilters } from '../AppBar/constants';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { homeSelector, storySelector } from '@/store/selectors';
import { useRouter } from 'next/router';
import { MuiIconButton } from '../IconButton';

interface CustomPopperProps {
  isOpen?: boolean;

  listItem: any;
  top?: any;
  extendedPalette?: any;
  handleCheckTypes: (value: any) => void;
}

export const FilterDropdown = ({ extendedPalette, top, isOpen, listItem, handleCheckTypes }: CustomPopperProps) => {
  const { t } = useTranslation();
  const [adminPalette, setAdminPalette] = useState({
    storyBackgroundColor: '#333333',
    textColor: '#fff',
    accentColor: '#BF5700',
  });
  const [selectedItem, setSelectedItem] = useState<string>();

  const [showSection, setShowSection] = useState(0);
  const router = useRouter();
  const tabs = getTabsFilters(setShowSection);
  const dispatch = useDispatch();
  const homeData = useSelector(homeSelector);
  const { story } = useSelector(storySelector);
  const [promptSelected, setPromptSelected] = useState(false);
  const [collabSelected, setCollabSelected] = useState(false);
  const { template } = useSelector(templatesSelector);
  const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('md'));
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const [profileAnchorEl, setProfileAnchorEl] = useState<null | HTMLElement>(null);

  const open = Boolean(anchorEl);

  const handleClickMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
    setProfileAnchorEl(null);
  };

  useEffect(() => {
    if (template?.template?.colors) {
      const colors = template.template.colors.reduce((acc: any, color: any) => {
        switch (color.PLabel) {
          case 'storyBackground':
            acc.storyBackgroundColor = color.PValue;
            break;
          case 'TextColor':
            acc.textColor = color.PValue;
            break;
          case 'AccentColor':
            acc.accentColor = color.PValue;
            break;
          default:
            break;
        }
        return acc;
      }, {});

      setAdminPalette({
        storyBackgroundColor: colors.storyBackgroundColor || '#333333',
        textColor: colors.textColor || '#fff',
        accentColor: colors.accentColor || '#BF5700',
      });
    }
  }, [template]);

  const accentColor = adminPalette.accentColor;
  let backgroundColor: any;

  let bgColor: any;
  let bgColorCheck: any;

  useEffect(() => {
    bgColor = router.pathname === '/app/home' ? palette.primary : accentColor;
    bgColorCheck = router.pathname === '/app/home' ? palette.primary : accentColor;
    backgroundColor = router.pathname === '/app/home' ? 'transparent' : adminPalette.storyBackgroundColor;
  }, [router, router?.pathname]);
  const handleMenuItemClick = (item: any) => {
    if (item.name === selectedItem) {
      return setSelectedItem(undefined);
      setAnchorEl(null);
      handleCheckTypes(null);
    }
    handleCheckTypes(item.id);
    setSelectedItem(item.name);
    setAnchorEl(null);
  };
  const typeOfStory = story?.story_details?.type_of_story;

  const options_user =
    typeOfStory === 'custom_event'
      ? [
          { id: 'all', name: 'Everyone' },
          { id: 'other', name: 'Other' },
          { id: 'family', name: 'Family' },
          { id: 'friend', name: 'Friends' },
          { id: 'fan', name: 'Fan' },
          { id: 'athlete', name: 'Athlete' },
          { id: 'player', name: 'Players' },
        ]
      : [
          { id: 'all', name: 'Everyone' },
          { id: 'other', name: 'Other' },
          { id: 'family', name: 'Family' },
          { id: 'friend', name: 'Friends' },
        ];

  return (
    <div>
      <Box onClick={handleClickMenu} sx={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}>
        <MuiIconButton
          icon='/icons/filter'
          label={!isMobile ? 'Filter' : 'Filter'}
          altIcon='filter'
          iconPosition='left'
          direction='row'
          background={!isMobile ? (extendedPalette?.hasCustomTheme ? `${extendedPalette.buttonbackgroundIcon} !important` : '#212d6d !important') : 'transparent'}
          width={!isMobile ? 120 : 70}
          isRounded={false}
          height={40}
          iconHeight={10}
          iconWidth={14}
          sx={{
            borderRadius: '24px',
            fontSize: '14px',
            '&:hover': {
              backgroundColor: `${extendedPalette?.hasCustomTheme ? extendedPalette.buttonbackgroundIcon : '#0072CE'} !important`,
              borderColor: `${extendedPalette?.hasCustomTheme ? extendedPalette.buttonbackgroundIcon : '#0072CE'}`,
            },
          }}
        />
      </Box>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleCloseMenu}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        sx={{
          '& .MuiPaper-root': {
            backgroundColor: '#D8E8F6',
            borderRadius: '12px',
            width: '115px',
            padding: '8px',
            top: '1rem',
            left: {
              xs: '0',
              sm: '0',
              md: '0',
              lg: '72% !important',
              xl: '0%',
            },
          },
        }}>
        {options_user.map((item, index) => (
          <div key={item.name}>
            <MenuItem
              onClick={() => {
                handleMenuItemClick(item);
              }}
              sx={{
                justifyContent: 'space-between',

                fontSize: '16px',

                backgroundColor: selectedItem === item.name ? '#0072CE' : 'transparent',
                color: selectedItem === item.name ? '#fff' : 'inherit',
                '&:hover': {
                  backgroundColor: '#0072CE',
                  color: '#fff',
                  '& .menu-icon': {
                    filter: 'brightness(0) invert(1)',
                  },
                },
              }}>
              {item.name}
            </MenuItem>
            {index !== options_user.length - 1 && <Divider />}
            {index < options_user.length && <hr style={{ backgroundColor: '#C6D7E7', border: 'none', margin: '0' }} />}
          </div>
        ))}
      </Menu>
    </div>
  );
};
